import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'semantic-ui-react'

import './Name.css'

class Name extends PureComponent {
  render() {
    const { align, asText, printable, team, useNick, widget } = this.props
    const name = useNick && !printable ? team.nickname : team.name
    return (
      <Table.Cell className="TeamName" textAlign={align} title={team.name}>
        <div className="TeamName__holder">
          {printable || asText ? (
            name
          ) : (
            <Link target={widget ? 'sweatbits' : null} to={`/sports/soccer/team/${team.id}`}>
              {name}
            </Link>
          )}
        </div>
      </Table.Cell>
    )
  }
}

Name.propTypes = {
  team: PropTypes.object.isRequired,

  align: PropTypes.oneOf(['left', 'right', 'center']),
  asText: PropTypes.bool,
  printable: PropTypes.bool,
  useNick: PropTypes.bool,
  widget: PropTypes.bool,
}

Name.defaultProps = {
  align: 'left',
  asText: false,
  printable: false,
  useNick: false,
  widget: false,
}

export default Name
